import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Partnership = ({ title, subtitle, richContent, partnerships, link, slug }) => {
  const elementRef = React.useRef(null)

  React.useEffect(() => {
    const line = elementRef.current?.querySelectorAll('.line');

    ScrollTrigger.create({
      trigger: '.partnership__bottom',
      start: "top bottom",
      onEnter: () => {
        line.forEach((el) => el.classList.add('is-inview'))
      },
    });

    return () => {
    };
  }, [slug]);


  const renderPartnerships = () => (
    <>
      {Array.from(
        { length: Math.ceil(partnerships.length / 4) },
        (_, index) => (
          <div key={index} className="partnership__items">
            <div className={`line line--horizon ${index % 2 ? 'center-left' : 'center-right'}`}></div>
            {partnerships.slice(index * 4, index * 4 + 4).map((el, i) => (
              <div className="partnership__item" key={i}>
                <div className={`line line--vertical ${index % 2 ? "center-top" : "center-bottom"}`}></div>
                <Asset asset={el} />
              </div>
            ))}
          </div>
        )
      )}
    </>
  )

  return (
    <section className="partnership">
      <div className="partnership__inner">
        <div className="partnership__wrapper" ref={elementRef}>
          <div className="line line--vertical center-bottom"></div>
          <div className="line line--horizon center-left"></div>
          <div className="partnership__top">
            {subtitle && <h3>{parse(subtitle)}</h3>}
            {title && <h2>{parse(title)}</h2>}
          </div>
          <div className="partnership__bottom">
            <div className="line line--horizon center-left"></div>
            {richContent && (
              <div className="partnership__content">
              {<StructuredText data={richContent} />}
              {link?.length > 0 && (<Link
                className="btn btn--orange"
                to={link[0].link[0].externalLink ? link[0].link[0].externalLink : link[0].link[0].internalLink.permalink}
              >
                {link[0].title}
              </Link>)}
            </div>)}

            <div className="partnership__clients">
              {renderPartnerships()}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Partnership

export const query = graphql`
  fragment PartnershipProps on DatoCmsPartnership {
    ... on DatoCmsPartnership {
      id
      title
      subtitle
      richContent {
        value
      }
      partnerships {
        ...InternalAssetProps
      }
      link {
        ...LinkWithTitleProps
      }
    }
  }
`